import React, { useState } from "react";

/**
 * Drop-in <img> replacement that:
 *  - Falls back to the SouthTrip Kerala default image if the src fails to load
 *  - Falls back if src is empty / null / a plain blob: id
 *  - Resolves API-relative URLs (/api/files/xxx) against REACT_APP_BACKEND_URL
 *  - Uses object-cover by default
 *
 * Usage: <SmartImage src={url} alt="..." className="..." />
 */
const FALLBACK = "/default-kerala-destination.svg";

const resolveSrc = (src) => {
    if (!src) return FALLBACK;
    if (src.startsWith("/api/")) {
        const base = process.env.REACT_APP_BACKEND_URL || "";
        return `${base}${src}`;
    }
    return src;
};

const SmartImage = ({
    src,
    alt = "",
    className = "",
    fallback = FALLBACK,
    loading = "lazy",
    ...rest
}) => {
    const [errored, setErrored] = useState(false);
    const finalSrc = errored ? fallback : resolveSrc(src);
    return (
        <img
            src={finalSrc}
            alt={alt}
            loading={loading}
            onError={() => {
                if (!errored) setErrored(true);
            }}
            className={`${className} object-cover object-center`}
            {...rest}
        />
    );
};

export default SmartImage;
